var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckYellow = function SvgCheckYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7ED",
    d: "M10 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    fillRule: "evenodd",
    d: "M13.633 7.752c.321.33.314.858-.016 1.179L9.33 13.098a.833.833 0 0 1-1.17-.009l-2.083-2.083a.833.833 0 1 1 1.178-1.179l1.502 1.503 3.697-3.594a.833.833 0 0 1 1.178.016Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckYellow;